import { Box, Checkbox, Text } from '@nimbus-ds/components';
import './TaskCheckboxCard.scss';

interface TaskCheckboxCardProps {
  task: { id: number; code: string; description?: string; label: string };
  checked: boolean;
  onChange: (id: number, checked: boolean) => void;
  hasError?: boolean;
  isRevamp?: boolean;
}

export function TaskCheckboxCard({
  task,
  checked,
  onChange,
  hasError = false,
  isRevamp = false,
}: Readonly<TaskCheckboxCardProps>) {
  const boxShadow = isRevamp || hasError ? '0' : '2';
  return (
    <Box
      data-style="stratus--card-box"
      padding="4"
      borderRadius="2"
      borderStyle="solid"
      borderWidth="1"
      borderColor={hasError ? 'danger-interactive' : 'transparent'}
      data-variant={hasError && isRevamp ? 'light-danger' : undefined}
      boxShadow={boxShadow}
    >
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <div className="stratus--checkbox-shadow">
          <Checkbox
            label={task.label}
            name={task.id.toString()}
            checked={checked}
            onChange={(e) => onChange(task.id, e.target.checked)}
          />
        </div>
        {!!task.description && (
          <Box
            flex="1"
            paddingLeft="5"
            paddingTop="1"
            data-style="stratus--card-description"
          >
            <Text as="span">{task.description}</Text>
          </Box>
        )}
      </Box>
    </Box>
  );
}
